import { InteractionType } from "@azure/msal-browser";
import { ApiServiceHandler, AuthenticationHandler, UseService } from "@haskoning/js-api-authentication-management";
import { ensureAuthenticated } from "@haskoning/msal";

import { ApiMethod } from "@/api/apiMethod";
import { loginRequest, msalInstance } from "@/msalAuthConfig";

const authenticationHandler = new AuthenticationHandler(
  "",
  "",
  "",
  "access",
  "refresh_token",
  null,
  "Authorization",
  "Bearer",
  true,
  true,
  (forceRefresh?: boolean) =>
    ensureAuthenticated(msalInstance, InteractionType.Popup, loginRequest, "access", forceRefresh)
);

const apiServiceHandler = new ApiServiceHandler(
  "",
  "",
  "",
  undefined,
  "access",
  "refresh_token",
  authenticationHandler
);

const useService = new UseService(apiServiceHandler);

export async function callApi<TData = unknown>(
  url: string,
  body?: unknown,
  method: ApiMethod = ApiMethod.GET
): Promise<TData> {
  if (method === ApiMethod.GET && body !== undefined) {
    throw new Error("A GET request cannot send a body. Put the parameters in the URL query string.");
  }

  const service = useService.service(url);

  let data: unknown;
  if (method === ApiMethod.GET) {
    data = await service.get();
  } else {
    data = await service.post(body ?? null);
  }

  return data as TData;
}
